import { render, staticRenderFns } from "./PazientiConsensiListComponent.vue?vue&type=template&id=6c70413f"
import script from "./PazientiConsensiListComponent.vue?vue&type=script&lang=js"
export * from "./PazientiConsensiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports